import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  buildScLookerFilterOptionsPayload,
  pickFilterOptions,
} from 'src/app/shared/helpers/sc-looker-filter-options.util';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';

/** Shared Speed & Consumption looker-studio-filter-options API access. */
@Injectable({ providedIn: 'root' })
export class ScLookerFilterCascadeService {
  constructor(private readonly dashboardService: DashboardService) {}

  /**
   * Loads cascading filter options from the same API used by Sailing Performance Database.
   */
  fetchFilterOptions(
    username: string | null,
    form: {
      clientStatus?: string | null;
      segment?: string | null;
      vesselStatus?: string | null;
      condition?: string | null;
      typeOfShip?: string | null;
      typeSpeed?: string | null;
      technicalOperator?: string | null;
      commercialOperator?: string | null;
    },
    selectedClients: string[],
    selectedShips: string[],
  ): Observable<ReturnType<typeof pickFilterOptions>> {
    const payload = buildScLookerFilterOptionsPayload(
      username,
      form,
      selectedClients,
      selectedShips,
    );

    return this.dashboardService
      .getLookerFilterOptions(payload)
      .pipe(map((res) => pickFilterOptions(res)));
  }
}
